import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
	button: {
		color: theme.palette.text.primary,
	},
}));
